module.exports = __webpack_public_path__ + "static/media/thumbnail3.6f13a403.jpg";